import { apiClient, handleResponse } from '@/utils/axios-client.ts'
import { z } from 'zod'

export const assignSiteToEmployee = async (
  userId: string,
  siteId: string
): Promise<void> => {
  return handleResponse(
    () => apiClient.put(`/api/v1/employees/${userId}/sites/${siteId}`),
    z.any()
  )
}

export const unassignSiteFromEmployee = async (
  userId: string,
  siteId: string
): Promise<void> => {
  return handleResponse(
    () => apiClient.delete(`/api/v1/employees/${userId}/sites/${siteId}`),
    z.any()
  )
}
